import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import PageBase from 'components/PageBase';
import {
  Button
} from '@material-ui/core';
import useRouter from 'utils/useRouter';
import * as API from 'services/api';
import { setLoading } from 'redux/actions/app';
import useStyles from '../styles';
import useHomeContext from 'layouts/HomeLayout/context';
import { PERPAGE } from 'config';
import { columnCreatedAt, columnId, filterTableData, exportUsersHeader, columnUser, columnActions, columnLoginInfo } from 'pages/common';
import ActionGroup from 'components/ActionGroup';
import ExportCSV from 'components/ExportCSV';
import DataTable from 'components/PageBase/dataTable';
import Tab from 'pages/Admins/tab';

const InternalUsers = ({ intl: { formatMessage } }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [users, setUsers] = useState([]);
  const [usersLoading, setUsersLoading] = useState(true);
  const [allUsersLoaded, setAllUsersLoaded] = useState(false);
  const [exportType, setExportType] = useState();
  const router = useRouter();
  const { onDeleteById } = useHomeContext();

  const [openFilter, setOpenFilter] = useState(false)
  const [filters, setFilters] = useState({})
  const [keyword, setKeyword] = useState('')

  const [teams, setTeams] = useState([]);
  useEffect(() => {
    API.listTeams({})
      .then(res => {
        if (res.code === 200) {
          setTeams(res.data);
        }
        dispatch(setLoading(false));
      })
      .catch(err => {
      });
  }, []);

  const loadUsers = (refresh) => {

    setUsersLoading(true);
    const page = refresh ? 1 : Number.parseInt(users.length / PERPAGE + 1, 10);

    const params = {
      page,
      perPage: PERPAGE,
      isApave: true,
      ...keyword && keyword.length > 0 ? { keyword } : {}
    };

    API.listUsers(params)
      .then(res => {
        if (res.code === 200) {
          setUsers(refresh ? res.users : [...users, ...res.users]);
          setAllUsersLoaded(res.users.length < PERPAGE);
        }
        dispatch(setLoading(false));
        setUsersLoading(false);
      })
      .catch(err => {
        dispatch(setLoading(false));
        setUsersLoading(false);
      });
  };

  useEffect(
    () => {
      setData([]);
      setUsers([]);
      setUsersLoading(true);
      setAllUsersLoaded(false);
      loadUsers(true);
    },
    [keyword],
  );
  const loadMore = () => {
    if (allUsersLoaded || usersLoading) {
      return;
    }
    loadUsers();
  };

  const loadExportData = (page, exportMode) => {
    const params = {
      page: page || 1,
      perPage: PERPAGE,
      ...keyword && keyword.length > 0 ? { keyword } : {}
    };


    dispatch(setLoading(true));
    API.listUsers(params).then(res => {
      if (res.code === 200) {
        const newUsers = res.users;
        setData(prev => [...prev, ...newUsers]);
        if (newUsers.length < PERPAGE) {
          dispatch(setLoading(false));
          setExportType(exportMode);
        } else {
          loadExportData(page + 1, exportMode);
        }
      }
    });
  };

  const onAdd = () => {
    router.history.push('/users/create', { internal: true });
  };

  const tableColumns = [
    columnId(formatMessage),
    {
      name: 'role',
      label: formatMessage({ id: 'role' }),
      options: { filter: true, sort: true, customBodyRender: value => formatMessage({ id: 'role.' + value }) },
    },
    ...columnUser(formatMessage),
    {
      name: 'team',
      label: formatMessage({
        id: 'teams',
      }),
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => {
          return value.map(item => teams.find(el => el.id == item)).filter(item => !!item).map(item => item.title).join(", ")
        }
      },
    },
    {
      name: 'status',
      label: formatMessage({ id: 'status' }),
      options: {
        filter: true,
        sort: true,
        customBodyRender: useCallback((value, tableMeta, updateValue) => (
          <FormattedMessage id={`home.users.${value.toLowerCase()}`} />
        ), []),
      },
    },
    ...columnLoginInfo(formatMessage),
    columnCreatedAt(formatMessage),
    columnActions(
      useCallback((value, tableMeta, updateValue) => (
        <ActionGroup
          onDelete={() => {
            onDeleteById(tableMeta.rowData[0]);
          }}
          onEdit={() => {
            router.history.push(`/user`, { id: tableMeta.rowData[0], internal: true });
          }}
        >
        </ActionGroup>
      ), [])
    )
  ];

  const datasource = filterTableData(users, filters);

  return (
    <PageBase title={formatMessage({ id: 'navbar.users.internal' })}
      rightComponent={<div className={classes.rightdom}>
        <Button onClick={onAdd} classes={{ root: classes.excel }}>
          <FormattedMessage id="home.user.create" />
        </Button>
        <ExportCSV
          filename="users"
          headers={exportUsersHeader(formatMessage)}
          data={data}
          loadExportData={loadExportData}
          exportType={exportType}
          setExportType={setExportType}
        />
      </div>}>
      <div>
        <Tab value={"users"} />
        <DataTable
          openFilter={openFilter}
          setOpenFilter={setOpenFilter}
          setFilters={setFilters}
          keyword={keyword}
          setKeyword={setKeyword}
          loadMore={loadMore}
          allUsersLoaded={allUsersLoaded}
          tableColumns={tableColumns}
          datasource={datasource}
          data={users}
        />
      </div>
    </PageBase>
  );
};

InternalUsers.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }),
};

export default injectIntl(InternalUsers);
